import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LinearProgress, Stack, Typography } from "@mui/material";
import { useTheme, darken, lighten } from "@mui/material/styles";
import CopyLinkButton from "../SendShareViaEmailButton/CopyLinkButton";
import CopyPasswordButton from "../../PasswordCopyButton";
import { useCreateShareContext } from "../../../hooks/context";
var ShareLinkDetails = function () {
    var _a, _b;
    var theme = useTheme();
    var _c = useCreateShareContext(), password = _c.password, loading = _c.loading, share = _c.shareLink;
    var shareType = ((_a = share === null || share === void 0 ? void 0 : share.authenticators) === null || _a === void 0 ? void 0 : _a.length)
        ? (_b = share.authenticators[0]) === null || _b === void 0 ? void 0 : _b.auth_type
        : "";
    var modify = theme.palette.mode === "dark" ? darken : lighten;
    if (loading) {
        return _jsx(LinearProgress, { color: "info" });
    }
    if (!shareType)
        return null;
    return (_jsxs(Stack, { gap: 1, children: [_jsx(Typography, { variant: "subtitle1", sx: { color: theme.palette.info.main }, children: "Your Generated Link" }), _jsxs(Typography, { variant: "body2", color: "textSecondary", children: [shareType === "sms_otp" &&
                        "This unique URL is protected with MFA using the phone number above.", shareType === "email_otp" &&
                        "This unique URL is protected with MFA using the email above.", shareType === "password" &&
                        "This unique URL is protected with MFA using the password below."] }), _jsx(CopyLinkButton, { value: share === null || share === void 0 ? void 0 : share.link, label: (share === null || share === void 0 ? void 0 : share.link) || "", variant: "contained", disableElevation: true, sx: {
                    bgcolor: modify(theme.palette.info.main, 0.9),
                    color: theme.palette.info.main,
                    ":hover": {
                        bgcolor: modify(theme.palette.info.main, 0.8),
                    },
                }, fullWidth: true, "data-testid": "Share-Copy-Btn", children: share === null || share === void 0 ? void 0 : share.link }), shareType === "password" && password && (_jsxs(Stack, { children: [_jsx(Typography, { variant: "body2", color: "textSecondary", children: "Password" }), _jsx(CopyPasswordButton, { value: password, label: password, variant: "contained", disableElevation: true, sx: {
                            bgcolor: modify(theme.palette.info.main, 0.9),
                            color: theme.palette.info.main,
                            ":hover": {
                                bgcolor: modify(theme.palette.info.main, 0.8),
                            },
                            paddingLeft: "0",
                            paddingRight: "0",
                        }, children: password })] }))] }));
};
export default ShareLinkDetails;
